import { getAppLanguage, toLocale } from "../../../utils/appLanguage";
import { RingSnapshot, Trend } from "./types";

// Generic helpers only. Areas, rings, bands, labels, moods and questions are NOT
// defined here: they come from GET /life-gps/config (see config.tsx).

export type RingAvg = { id: string; label: string; weight: number; avg: number | null; count: number };
export type Composite = {
  score: number | null;
  rings: RingAvg[];
  trend: Trend;
  delta: number;
};

// The Astria Score exactly as the backend computed it (single source of truth).
export const compositeOf = (snap: RingSnapshot): Composite => {
  const a = snap.astriaScore;
  return {
    score: a.score == null ? null : Math.round(a.score),
    rings: a.rings,
    trend: a.trend,
    delta: Math.round(a.delta),
  };
};

// "5 minutes ago" etc. in the user's preferred language.
export const timeAgo = (iso?: string | null) => {
  if (!iso) return "";
  const mins = Math.max(0, Math.round((Date.now() - new Date(iso).getTime()) / 60000));
  const rtf = new Intl.RelativeTimeFormat(toLocale(getAppLanguage()), { numeric: "auto", style: "short" });
  if (mins < 60) return rtf.format(-Math.max(1, mins), "minute");
  if (mins < 60 * 24) return rtf.format(-Math.round(mins / 60), "hour");
  return rtf.format(-Math.round(mins / (60 * 24)), "day");
};
